import React from 'react';
import { Link } from 'react-router-dom';
import cl from './Stub.module.css';
import { IconArrowRight } from '../components/icons';

export default function NotFound() {
    return (
        <main className={cl.page}>
            <span className={cl.eyebrow}>404</span>
            <h1 className={cl.title}>Страница не найдена</h1>
            <p className={cl.text}>
                Возможно, ссылка устарела или вы ошиблись адресом. Вернитесь на главную
                — там тоже интересно.
            </p>
            <div className={cl.actions}>
                <Link to="/" className={cl.btn}>На главную <IconArrowRight width={16} height={16}/></Link>
            </div>
        </main>
    );
}
